import { render, staticRenderFns } from "./userCost.vue?vue&type=template&id=ac5b2348&scoped=true&"
import script from "./userCost.vue?vue&type=script&lang=ts&"
export * from "./userCost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5b2348",
  null
  
)

export default component.exports